module.exports = __webpack_public_path__ + "img/base-desc.2a9e50de.svg";